import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton, SkeletonGroup } from '@/components/ui/skeleton'
import { useEventCameraMedia } from '@/models/dashboard'

function Footage({ label, videoUrl }: { label: string; videoUrl: string }) {
  return (
    <div>
      <p className="mb-2 text-sm font-medium">{label}</p>
      <video src={videoUrl} controls className="max-h-64 w-full rounded-lg object-contain">
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

/** Dashcam footage for a telematics safety event. */
export function CameraMedia({ eventId }: { eventId: string }) {
  const { data, isLoading } = useEventCameraMedia(eventId)

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Camera footage</CardTitle>
        </CardHeader>
        <CardContent>
          <SkeletonGroup className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <Skeleton className="h-64 w-full" />
            <Skeleton className="h-64 w-full" />
          </SkeletonGroup>
        </CardContent>
      </Card>
    )
  }

  if (!data?.frontFacing && !data?.rearFacing) {
    return null
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Camera footage</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {data.frontFacing && <Footage label="Front facing" videoUrl={data.frontFacing.videoUrl} />}
          {data.rearFacing && <Footage label="Rear facing" videoUrl={data.rearFacing.videoUrl} />}
        </div>
      </CardContent>
    </Card>
  )
}
